import { render, staticRenderFns } from "./EodbOtherDetails.vue?vue&type=template&id=11593bf1&scoped=true&"
import script from "./EodbOtherDetails.vue?vue&type=script&lang=js&"
export * from "./EodbOtherDetails.vue?vue&type=script&lang=js&"
import style0 from "./EodbOtherDetails.vue?vue&type=style&index=0&id=11593bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11593bf1",
  null
  
)

export default component.exports